import {api} from '../../../services/api';

export interface FunifierItem {
  _id: string;
  parent: string;
  image: {
    small?: { url: string };
    medium?: { url: string };
    original: { url: string };
  };
  
  image_red?: {
    original: { url: string };
  };
  image_yellow?: {
    original: { url: string };
  };
  image_green?: {
    original: { url: string };
  };
  image_blue1?: {
    original: { url: string };
  };
  image_blue2?: {
    original: { url: string };
  };
  image_brown?: {
    original: { url: string };
  };
  color: string;
  rotation: number;
  scale: number;
  description: string;
  title: string;
  blendMode: string;
  x: number;
  y: number;
  zIndex: number;
  virtualgoods?: string; 
  imageCatalog?: {
    original?: { url: string };
    small?: { url: string };
    medium?: { url: string };
  };
}

export interface FunifierResponse {
  itens: FunifierItem[];
}

const categoryMapping: Record<string, string> = {
  'upper_body': 'shirt',
  'lower_body': 'pants',
  'hair': 'hair',
  'face': 'face',
  'accessories': 'accessories',
  'shoes': 'shoes',
  'hat': 'hat',
  'glasses': 'glasses',
  'bag': 'bag',
  
  'body': 'face',
  'emotion': 'face',
  'lock': 'lock',
  'gamepad': 'gamepad',
  'gift': 'gift',
  'background': 'background',
  'scenario': 'background',
  'game': 'gamepad',
  'special': 'gift'
};

export async function fetchFunifierItems(): Promise<FunifierItem[]> {
  const { data } = await api.post<FunifierResponse[]>('/find/get_avatar_parts', {});

  if (data.length > 0 && data[0].itens) {
    return data[0].itens;
  }

  return [];
}

export function convertFunifierToAvatarItem(funifierItem: FunifierItem): import('../types/types').AvatarItem {
  const category = categoryMapping[funifierItem.parent] || funifierItem.parent;
  
  
  
  if (category === 'base') {
    throw new Error(`Item do Funifier não pode ter categoria 'base': ${funifierItem._id}`);
  }
  
  
  if (!funifierItem.image || !funifierItem.image.original) {
        throw new Error(`Item ${funifierItem._id} não possui estrutura de imagem válida`);
  }
  
  
  let catalogImage: string;
  
  
  if (funifierItem.imageCatalog?.small?.url) {
    catalogImage = funifierItem.imageCatalog.small.url;
      } else if (funifierItem.imageCatalog?.medium?.url) {
    catalogImage = funifierItem.imageCatalog.medium.url;
      } else if (funifierItem.imageCatalog?.original?.url) {
    catalogImage = funifierItem.imageCatalog.original.url;
      }
  
  else if (funifierItem.image.small?.url) {
    catalogImage = funifierItem.image.small.url;
      } else if (funifierItem.image.medium?.url) {
    catalogImage = funifierItem.image.medium.url;
      } 
  
  else {
    const originalUrl = funifierItem.image.original.url;
    catalogImage = createOptimizedCatalogUrl(originalUrl, 100, 100);
      }
  
    
    const colorVariants = {
    image_red: funifierItem.image_red?.original?.url,
    image_yellow: funifierItem.image_yellow?.original?.url,
    image_green: funifierItem.image_green?.original?.url,
    image_blue1: funifierItem.image_blue1?.original?.url,
    image_blue2: funifierItem.image_blue2?.original?.url,
    image_brown: funifierItem.image_brown?.original?.url
  };

  
  const virtualGoodId = funifierItem.virtualgoods || undefined;
  const isPaid = !!funifierItem.virtualgoods; 

    return {
    id: funifierItem._id,
    src: funifierItem.image.original.url,
    x: funifierItem.x,
    y: funifierItem.y,
    
    zIndex: category === 'shoes' ? 0.5 : funifierItem.zIndex,
    category: category,
    scale: funifierItem.scale,
    rotation: funifierItem.rotation,
    color: funifierItem.color,
    title: funifierItem.title,
    description: funifierItem.description,
    catalogImage: catalogImage,
    virtualGoodId: virtualGoodId,
    isPaid: isPaid,
    ...colorVariants 
  };
}

export function debugFunifierStructure(items: FunifierItem[], maxItems = 3) {
    
  const allCategories = Array.from(new Set(items.map(item => item.parent)));
    
  const categoryCount: Record<string, number> = {};
  items.forEach(item => {
    categoryCount[item.parent] = (categoryCount[item.parent] || 0) + 1;
  });
  
    Object.entries(categoryCount).forEach(([category, count]) => {
    const mappedCategory = categoryMapping[category] || category;
      });
  
  items.slice(0, maxItems).forEach((item, index) => {
                            if (item.imageCatalog) {
                      }
  });
}

export function createOptimizedCatalogUrl(originalUrl: string, maxWidth = 100, maxHeight = 100): string {
  try {
    const url = new URL(originalUrl);
    
    
    if (url.hostname.includes('cloudinary.com')) {
      
      const pathParts = url.pathname.split('/');
      const uploadIndex = pathParts.indexOf('upload');
      if (uploadIndex !== -1 && uploadIndex < pathParts.length - 1) {
        pathParts.splice(uploadIndex + 1, 0, `w_${maxWidth},h_${maxHeight},c_fit,q_auto,f_auto`);
        url.pathname = pathParts.join('/');
        return url.toString();
      }
    }
    
    
    url.searchParams.set('w', maxWidth.toString());
    url.searchParams.set('h', maxHeight.toString());
    url.searchParams.set('fit', 'cover');
    
    return url.toString();
  } catch (error) {
        return originalUrl;
  }
}
